module.exports = __webpack_public_path__ + "static/elizabeth-bio-a370fdd0170d767460f63dc52d540ef2.png";